"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navNodesToReactRouteItems = void 0;
function mapNode(n) {
    const hasChildren = n.children && n.children.length > 0;
    if (n.type === 'group' || hasChildren) {
        return {
            type: 'group',
            title: n.menuKey,
            msg: n.msg,
            roles: n.roles ? n.roles.slice() : undefined,
            children: n.children.map(mapNode),
        };
    }
    return {
        title: n.menuKey,
        msg: n.msg,
        path: n.path,
        permission: n.permission,
        roles: n.roles ? n.roles.slice() : undefined,
        adminOnly: !!(n.adminOnly || n.adminRoleOnly),
        icon: n.icon,
    };
}
function navNodesToReactRouteItems(nodes) {
    return nodes.map(mapNode);
}
exports.navNodesToReactRouteItems = navNodesToReactRouteItems;
